/** A moment as a form edits it: a calendar day and an "HH:MM" time, both local. */
export interface LocalSchedule {
  day: Date;
  time: string;
}

const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;

/** The local day and time as an ISO instant; null for a time that is not "HH:MM". */
export function localScheduleToIso(schedule: LocalSchedule): string | null {
  const match = TIME_RE.exec(schedule.time);
  if (!match) return null;
  const { day } = schedule;
  return new Date(
    day.getFullYear(),
    day.getMonth(),
    day.getDate(),
    Number(match[1]),
    Number(match[2]),
  ).toISOString();
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** An ISO instant as the local day and time a form shows. */
export function isoToLocalSchedule(iso: string): LocalSchedule {
  const at = new Date(iso);
  return {
    day: new Date(at.getFullYear(), at.getMonth(), at.getDate()),
    time: `${pad(at.getHours())}:${pad(at.getMinutes())}`,
  };
}

/** Where a new schedule starts: the next whole hour from `now`, local. */
export function defaultSchedule(now: Date): LocalSchedule {
  const next = new Date(now);
  next.setMinutes(0, 0, 0);
  next.setHours(next.getHours() + 1);
  return isoToLocalSchedule(next.toISOString());
}
